import kformUtils from '../utils/kform-utils';

const forceDisplayComponentsInReadOnlyMode = new Set([
	'form',
	'wfCurrent',
]);

const kformFormController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.options = $scope.options || {};
	$scope.alerts = [];
	$scope.iframeReady = false;
	$scope.formName = $scope.name || 'kformForm';
	// Shows the given alerts (single or array), and dismisses old alerts
	$scope.showAlerts = (/** @type {{ message: string; }} */ alerts) => {
		/* eslint-disable no-empty */
		try {
			alerts.message = (JSON.parse(alerts.message)).data;
		}
		catch {}
		/* eslint-enable no-empty */

		$scope.alerts = [alerts].flat();
	};

	// Create the scope object.
	// $scope.formScope = KformScope.register($scope);
	$scope.formScope = {};

	$scope.isVisible = (
		/** @type {any} */ component,
		/** @type {any} */ row,
	) => {
		if (
			$scope.form.readOnly && component?.input
			&& kformUtils.isEmpty($scope.form.submission.data[component.key])
			&& !forceDisplayComponentsInReadOnlyMode.has(component.type)
		) {
			return false;
		}
		if (forceDisplayComponentsInReadOnlyMode.has(component.type) && !component.hidden) {
			return true;
		}
		return kformUtils.isVisible(
			component,
			row,
			$scope.form.submission ? $scope.form.submission.data : null,
			$scope.hideComponents,
			$scope.form,
		);
	};

	$scope.isDisabled = (
		/** @type {any} */ component,
	) => $scope.form.readOnly || component.disabled || (Array.isArray($scope.disableComponents)
		&& $scope.disableComponents.includes(component.key));

	$scope.isRequired = (/** @type {any} */ component) => kformUtils.isRequired(component, $scope.requireComponents);
};

export default kformFormController;
